module.exports = __webpack_public_path__ + "img/image-stand-out.a7152be7.jpg";